import { Component, OnInit } from '@angular/core';
import { MiinteressaComponent } from '../miinteressa/miinteressa.component';
import { environment } from "../../environments/environment";

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.css', '../../styles/main2.css', '../../styles/bff36bfa-92c9-4b5f-9ec6-a50300d6c6b3.css']
})
export class WelcomeComponent implements OnInit {
  env: any;
  
  constructor() {
    this.env = environment;
  }

  ngOnInit() {
      let m = new MiinteressaComponent();
      m.doAnimation();
  }

}
